import React from 'react';
import classes from './SurveyStatusTag.module.css';

export interface SurveyStatusTagProps {
  status: 'ONGOING' | 'COMPLETED' | 'EXPIRED';
  translations: {
    ongoing: string;
    completed: string;
    expired: string;
  };
}

/**
 * Displays survey status as a colored tag
 * - Green: Completed
 * - Yellow: Ongoing
 * - Red: Expired
 */
export const SurveyStatusTag: React.FC<SurveyStatusTagProps> = ({ status, translations }) => {
  const getClassName = () => {
    switch (status) {
      case 'COMPLETED':
        return classes.statusCompleted;
      case 'ONGOING':
        return classes.statusOngoing;
      case 'EXPIRED':
        return classes.statusExpired;
    }
  };

  const getText = () => {
    switch (status) {
      case 'COMPLETED':
        return translations.completed;
      case 'ONGOING':
        return translations.ongoing;
      case 'EXPIRED':
        return translations.expired;
    }
  };

  return <span className={getClassName()}>{getText()}</span>;
};
